import { toast } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateSalaryAdvanceMutation } from "../api/queries";
import {
  AdvanceRequestForm,
  type AdvanceRequestFormValues,
} from "../components/AdvanceRequestForm";

const LIST_SEARCH = {
  offset: 0,
  limit: 20,
  status: undefined as string | undefined,
};

export function NewAdvanceRequestPage() {
  const nav = useNavigate();
  const createMutation = useCreateSalaryAdvanceMutation();

  const handleBack = () => {
    nav({ to: "/app/hr/salary-advance/requests", search: LIST_SEARCH });
  };

  const handleSubmit = (values: AdvanceRequestFormValues) => {
    createMutation.mutate(
      {
        requestDate: values.requestDate,
        amount: Number(values.amount),
        reason: values.reason.trim() || null,
      },
      {
        onSuccess: (result) => {
          toast.success("ຍື່ນຄຳຂໍສຳເລັດ");
          nav({
            to: "/app/hr/salary-advance/requests/$id",
            params: { id: result.id },
          });
        },
        onError: (err: { message?: string }) => {
          const msg = err?.message ?? "";
          if (msg.includes("ADVANCE_ALREADY_ACTIVE")) {
            toast.error("ທ່ານມີຄຳຂໍທີ່ຢູ່ໃນລະຫວ່າງດຳເນີນການຢູ່ແລ້ວ ກະລຸນາລໍຖ້າຈົນຄຳຂໍເກົ່າສຳເລັດ");
            return;
          }
          toast.error(msg || "ເກີດຂໍ້ຜິດພາດ");
        },
      },
    );
  };

  return (
    <>
      <Header />
      <Main>
        <div className="mb-6">
          <h1 className="font-semibold text-2xl">ຍື່ນຄຳຂໍເບິກເງິນເດືອນລ່ວງໜ້າ</h1>
          <p className="text-muted-foreground text-sm">
            ຕື່ມຂໍ້ມູນດ້ານລຸ່ມ ແລ້ວກົດ "ຍື່ນຄຳຂໍ"
          </p>
        </div>

        <div className="mx-auto w-full max-w-lg">
          <AdvanceRequestForm
            onSubmit={handleSubmit}
            onCancel={handleBack}
            isSubmitting={createMutation.isPending}
          />
        </div>
      </Main>
    </>
  );
}
